var _defs, _polygon, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVrCone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 234.14 128.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 117.07,
    y1: 109.25,
    x2: 117.07,
    y2: 7.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2951f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2951f",
    stopOpacity: 0
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "234.14 0 117.07 117.07 0 0 234.14 0",
    fill: "url(#linear-gradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.07,
    cy: 119.29,
    r: 8.9,
    fill: "#f2951f",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrCone);
export default __webpack_public_path__ + "static/media/vr_cone.3ad8b6cba51df5dc58b1e5eba26a321b.svg";
export { ForwardRef as ReactComponent };